export default "__VITE_ASSET__af4591dc__"